"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QrBill = void 0;
const dompurify_1 = __importDefault(require("dompurify"));
const react_1 = __importDefault(require("react"));
const svg_1 = require("swissqrbill/lib/browser/esm/browser/svg");
/**
 * Component to create an SVG for a Swiss QR Bill.
 */
const QrBill = (props) => {
    const svg = new svg_1.SVG(props.data, { language: props.language });
    // Original size is 210mm x 105mm with borders of 5mm.
    // We use a viewBox of "0mm 0mm 210mm 105mm" converted to pixels.
    svg.element.setAttribute("viewBox", "0 0 793.700 396.850");
    svg.element.setAttribute("width", "100%");
    svg.element.removeAttribute("height");
    if (props.horizontalLine) {
        const horizontalLine = document.createElementNS("http://www.w3.org/2000/svg", "line");
        horizontalLine.setAttribute("x1", "0");
        horizontalLine.setAttribute("y1", "0");
        horizontalLine.setAttribute("x2", "100%");
        horizontalLine.setAttribute("y2", "0");
        horizontalLine.setAttribute("stroke", "black");
        horizontalLine.setAttribute("stroke-dasharray", "3");
        horizontalLine.setAttribute("stroke-width", "1");
        svg.element.append(horizontalLine);
    }
    return (react_1.default.createElement("div", { style: { width: "100%" }, dangerouslySetInnerHTML: { __html: dompurify_1.default.sanitize(svg.element) } }));
};
exports.QrBill = QrBill;
